import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { ChoiceGrid, StepFooter, StepHeader } from "./_widgets";

const HORMONES = [
  { value: "no", label: "No" },
  { value: "trt", label: "Testosterone Replacement (TRT)" },
  { value: "other", label: "Other" },
];

const DIETED = [
  { value: "no", label: "No" },
  { value: "currently", label: "Currently dieting" },
  { value: "within_6mo", label: "Within the last 6 months" },
];

const WEIGHT_CHANGE = [
  { value: "lost", label: "Lost weight" },
  { value: "maintained", label: "Maintained" },
  { value: "gained", label: "Gained weight" },
];

export default function Step7Health({ data, set, onNext, saving }) {
  const valid =
    !!data.medications &&
    !!data.hormone_therapy &&
    !!data.dieted_recently &&
    !!data.weight_change_6mo;

  return (
    <div className="space-y-5">
      <StepHeader title="Health History" subtitle="Last questions — this stays private." />

      <div className="space-y-1.5">
        <Label>Any medications?</Label>
        <Textarea
          rows={2}
          placeholder="List anything relevant, or write 'None'"
          value={data.medications}
          data-testid="onb-meds"
          onChange={(e) => set({ medications: e.target.value })}
        />
      </div>

      <div className="space-y-1.5">
        <Label>Performance-enhancing drugs or hormone therapy?</Label>
        <ChoiceGrid
          options={HORMONES}
          value={data.hormone_therapy}
          onChange={(v) => set({ hormone_therapy: v })}
          testid="onb-hormones"
        />
      </div>

      <div className="space-y-1.5">
        <Label>Have you dieted recently?</Label>
        <ChoiceGrid
          options={DIETED}
          value={data.dieted_recently}
          onChange={(v) => set({ dieted_recently: v })}
          testid="onb-dieted"
        />
      </div>

      <div className="space-y-1.5">
        <Label>Weight change in the last 6 months</Label>
        <ChoiceGrid
          options={WEIGHT_CHANGE}
          value={data.weight_change_6mo}
          onChange={(v) => set({ weight_change_6mo: v })}
          testid="onb-weight-change"
        />
      </div>

      <StepFooter
        valid={valid && !saving}
        onNext={onNext}
        nextLabel={saving ? "Saving…" : "Continue →"}
      />
    </div>
  );
}
